import React from 'react';
import { IMatch } from '@/models/match';
import { useCombinedEvents } from '@/utils/useCombinedEvents';
import MatchTimeline from './match-timeline';

const MatchLiveData: React.FC<{ matchData: IMatch }> = ({ matchData }) => {
	const combinedEvents = useCombinedEvents(matchData.live_data);

	return (
		<>
			{combinedEvents.length > 0 && (
				<>
					<MatchTimeline
						combinedEvents={combinedEvents}
						homeId={matchData.homeContestant.contestantId}
						awayId={matchData.awayContestant.contestantId}
					/>
				</>
			)}
		</>
	);
};

export default MatchLiveData;
